// ─── CSS Custom Properties ─────────────────────────────────────
export function generateCSSVariables(brand) {
    const { colors, typography, logo } = brand;
    const vars = [];
    vars.push(`  --brand-primary: ${colors.primary}`);
    if (colors.primary_light)
        vars.push(`  --brand-primary-light: ${colors.primary_light}`);
    if (colors.primary_dark)
        vars.push(`  --brand-primary-dark: ${colors.primary_dark}`);
    if (colors.secondary)
        vars.push(`  --brand-secondary: ${colors.secondary}`);
    if (colors.accent)
        vars.push(`  --brand-accent: ${colors.accent}`);
    if (colors.background)
        vars.push(`  --brand-background: ${colors.background}`);
    if (colors.surface)
        vars.push(`  --brand-surface: ${colors.surface}`);
    if (colors.text)
        vars.push(`  --brand-text: ${colors.text}`);
    if (colors.text_secondary)
        vars.push(`  --brand-text-secondary: ${colors.text_secondary}`);
    if (colors.semantic?.success)
        vars.push(`  --brand-success: ${colors.semantic.success}`);
    if (colors.semantic?.warning)
        vars.push(`  --brand-warning: ${colors.semantic.warning}`);
    if (colors.semantic?.error)
        vars.push(`  --brand-error: ${colors.semantic.error}`);
    if (colors.semantic?.info)
        vars.push(`  --brand-info: ${colors.semantic.info}`);
    if (typography?.heading_font)
        vars.push(`  --brand-heading-font: '${typography.heading_font}'`);
    if (typography?.body_font)
        vars.push(`  --brand-body-font: '${typography.body_font}'`);
    if (logo?.primary_url)
        vars.push(`  --brand-logo-url: url('${logo.primary_url}')`);
    return `:root {\n${vars.map(v => `${v};`).join('\n')}\n}`;
}
// ─── Tailwind Color Map ────────────────────────────────────────
export function generateTailwindConfig(brand) {
    const { colors } = brand;
    const result = { 'brand-primary': colors.primary };
    if (colors.primary_light)
        result['brand-primary-light'] = colors.primary_light;
    if (colors.primary_dark)
        result['brand-primary-dark'] = colors.primary_dark;
    if (colors.secondary)
        result['brand-secondary'] = colors.secondary;
    if (colors.accent)
        result['brand-accent'] = colors.accent;
    if (colors.background)
        result['brand-background'] = colors.background;
    if (colors.surface)
        result['brand-surface'] = colors.surface;
    if (colors.text)
        result['brand-text'] = colors.text;
    if (colors.text_secondary)
        result['brand-text-secondary'] = colors.text_secondary;
    return result;
}
//# sourceMappingURL=css-generator.js.map